var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZksync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 243,
    height: 138,
    viewBox: "0 0 243 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M242.741 68.886L173.91 0.127441V50.4835L105.567 100.9L173.91 100.948V137.645L242.741 68.886Z",
    fill: "#4E529A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.100006 68.861L68.931 137.619V87.7965L136.773 37.346L68.931 37.2995V0.102539L0.100006 68.861Z",
    fill: "#8C8DFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZksync);
export default __webpack_public_path__ + "static/media/zksync.54d9fa4a32a62cdd82552db7d287f19b.svg";
export { ForwardRef as ReactComponent };